export const hidden = (condition: boolean) => (condition ? 'hidden' : '');
